export const handlePostData = (params: any) => {
  const { current, pageSize, queryParam } = params;
  const convertValues: any = {};
  convertValues.pageNo = current;
  convertValues.pageSize = pageSize;
  convertValues.queryParam = queryParam;
  return convertValues;
};
